/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { AssociatedCompanyEditorViewModel } from "../types/AssociatedCompanyEditorViewModel.ts";
import { associatedCompanyAddressViewModelSchema } from "./associatedCompanyAddressViewModelSchema.ts";
import { eAssociateCompanyTotalEmployeesSchema } from "./eAssociateCompanyTotalEmployeesSchema.ts";
import { eAssociatedCompanyStatusSchema } from "./eAssociatedCompanyStatusSchema.ts";
import { eCompanySizeSchema } from "./eCompanySizeSchema.ts";

export const associatedCompanyEditorViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  companyId: z.number().int().nullish(),
  code: z.string().nullish(),
  name: z.string().nullish(),
  tradeName: z.string().nullish(),
  document: z.string().nullish(),
  stateRegistration: z.string().nullish(),
  email: z.string().nullish(),
  phone: z.string().nullish(),
  contact: z.string().nullish(),
  status: z.optional(
    z
      .lazy(() => eAssociatedCompanyStatusSchema)
      .describe("1 = Associated | 2 = InProcess | 3 = NotAssociated | "),
  ),
  partnershipDateStart: z.string().datetime().nullish(),
  partnershipDateEnd: z.string().datetime().nullish(),
  partnerId: z.optional(z.number().int()),
  discountTypeId: z.optional(z.number().int()),
  poloId: z.number().int().nullish(),
  responsiblePersonId: z.number().int().nullish(),
  validateEmail: z.optional(z.boolean()),
  validateCpf: z.optional(z.boolean()),
  validateDomain: z.optional(z.boolean()),
  validateDocumentation: z.optional(z.boolean()),
  domain1: z.string().nullish(),
  domain2: z.string().nullish(),
  domain3: z.string().nullish(),
  domain4: z.string().nullish(),
  domain5: z.string().nullish(),
  occupationArea: z.string().nullish(),
  companySize: z.optional(
    z
      .lazy(() => eCompanySizeSchema)
      .describe(
        "1 = MEI | 2 = ME | 3 = EPP | 4 = LTDA | 5 = SA | 6 = NotApplicable | ",
      ),
  ),
  totalEmployees: z.optional(
    z
      .lazy(() => eAssociateCompanyTotalEmployeesSchema)
      .describe(
        "1 = From0To50 | 2 = From50To100 | 3 = From100To500 | 4 = From500To1000 | 5 = HigherThan1000 | ",
      ),
  ),
  notListed: z.optional(z.boolean()),
  hideFinancialData: z.optional(z.boolean()),
  active: z.optional(z.boolean()),
  address: z.optional(z.lazy(() => associatedCompanyAddressViewModelSchema)),
}) as unknown as ToZod<AssociatedCompanyEditorViewModel>;
